{
  "name": "spartacusstore",
  "version": "123.126.834",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --ssl true --host 0.0.0.0",
    "build": "ng build --configuration=development",
    "build:dev": "ng build --configuration=development",
    "build:dev2": "ng build --configuration=development2",
    "build:stage": "ng build --configuration=stage",
    "build:prod": "ng build --configuration=production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "local": "ng serve --configuration=local --ssl true"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "~19.2.11",
    "@angular/cdk": "~19.2.11",
    "@angular/common": "~19.2.11",
    "@angular/compiler": "~19.2.11",
    "@angular/core": "~19.2.11",
    "@angular/forms": "~19.2.11",
    "@angular/material": "~19.2.11",
    "@angular/platform-browser": "~19.2.11",
    "@angular/platform-browser-dynamic": "~19.2.11",
    "@angular/router": "~19.2.11",
    "@angular/service-worker": "~19.2.11",
    "@angular/ssr": "^19.0.4",
    "@auth0/auth0-angular": "^2.1.0",
    "@fontsource/open-sans": "^5.2.5",
    "@fortawesome/fontawesome-free": "6.7.2",
    "@ng-select/ng-select": "^14.7.0",
    "@ngrx/effects": "~19.2.0",
    "@ngrx/operators": "^19.2.0",
    "@ngrx/router-store": "~19.2.0",
    "@ngrx/store": "~19.2.0",
    "@spartacus/asm": "~221121.5",
    "@spartacus/assets": "~221121.5",
    "@spartacus/cart": "~221121.5",
    "@spartacus/checkout": "~221121.5",
    "@spartacus/core": "~221121.5",
    "@spartacus/order": "~221121.5",
    "@spartacus/pdf-invoices": "~221121.5",
    "@spartacus/product": "~221121.5",
    "@spartacus/product-configurator": "~221121.5",
    "@spartacus/setup": "~221121.5",
    "@spartacus/smartedit": "~221121.5",
    "@spartacus/storefront": "~221121.5",
    "@spartacus/styles": "~221121.5",
    "@spartacus/tracking": "~221121.5",
    "@spartacus/user": "~221121.5",
    "angular-oauth2-oidc": "^19.0.0",
    "dpop": "^2.1.1",
    "i18next": "^24.2.3",
    "i18next-http-backend": "^3.0.2",
    "i18next-resources-to-backend": "^1.2.1",
    "jasmine-marbles": "0.9.2",
    "moment": "^2.29.4",
    "ngx-infinite-scroll": "^19.0.0",
    "rxjs": "^7.8.1",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/core": "^19.2.12",
    "@angular-devkit/schematics": "~19.2.12",
    "@angular/build": "19.2.15",
    "@angular/cli": "~19.2.12",
    "@angular/compiler-cli": "~19.2.11",
    "@spartacus/schematics": "~221121.5",
    "@types/jasmine": "~4.0.0",
    "jasmine-core": "~4.3.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "typescript": "~5.8.3"
  }
}
